<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .upload-item-right {
    display: flex;
    align-items: center;
    gap: 0px;
  }
</style>

<script>
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";
  import Icon from "@sourcewhale/shared/svelte-design-system/components/atoms/Icon.svelte";
  import { onMount } from "svelte";
  import { updateUploadsNotifications } from "../../../../../../api/uploads-notifications";
  import { todosModalItemStore } from "../../../../../modals/TodosModal/stores";
  import { PROCESSED_STATUSES } from "../../assets";
  import { uploadsModalStore, uploadsNotificationsStore } from "../../stores";

  let { upload } = $props();

  let modalExists = $state(false);

  onMount(() => {
    modalExists = document.getElementById("todos-modal");
  });

  const handleDismiss = async (upload) => {
    updateUploadsNotifications({
      ids: [upload["notificationId"]],
      status: "deleted",
    });
    uploadsNotificationsStore.update((store) => ({
      notifications: store.notifications.filter(
        (n) => n.notificationId !== upload.notificationId
      ),
    }));
  };

  const handleView = (upload) => {
    const candidateId = upload?.candidates[0]?.candidateId;
    if (!candidateId) {
      return;
    }
    if (!modalExists || window.location.pathname == "/todo") {
      window.location = "/contacts?openContactModalWithId=" + candidateId;
      return;
    }

    todosModalItemStore.set({
      candidateId: candidateId,
      toDoId: null,
    });
    uploadsModalStore.set(false);
  };
</script>

<div class="upload-item-right">
  {#if upload.status === "done"}
    <Button
      onclick={() => handleView(upload)}
      kind="ghost-blue"
      size="xsmall"
      trailingIcon="fa-arrow-up-right"
    >
      View
    </Button>
  {/if}

  {#if PROCESSED_STATUSES.includes(upload.status)}
    <Button kind="ghost-grey" onclick={() => handleDismiss(upload)}>
      <Icon class="fa-regular fa-xmark" size="small" />
    </Button>
  {/if}
</div>
